<template>
  <div>
    <Loader v-if="isLoading"></Loader>
    <div v-else-if="!isLoading && items.length < 1">
      {{ $t('views.excmtask.list.NoTask') }}
    </div>
    <TasksTable :items="items" v-else
                :display-assigned="displayAssigned"
                :toggle-create-task-modal="toggleCreateTaskModal"
                :get-data="getData"
                @selectedCase="updateSelectedCase($event)"/>
    <pagination
      v-if="view"
      :view="view"
      @getPageNumber="setPageNum($event.page, $event.itemsPerPage)"
    ></pagination>
    <b-dropdown v-if="!displayAssigned || $route.name === 'EXCMTaskList'" :disabled="$store.state.checkboxes.selectedTasks.length === 0" size="sm" variant="warning" dropright text="Drop-Right">
      <template #button-content>
        {{ $t('buttons.collectionOperations') }}
      </template>
      <b-dropdown-item @click="takeMultipleTasks()"><i class="fa fa-file-check mr-2"></i>{{$t('views.excmtask.list.takeMultipleTasks')}}</b-dropdown-item>
    </b-dropdown>
    <dispatch-task-modal v-if="$route.name === 'EXCMTaskList'"></dispatch-task-modal>
    <add-to-my-calendar-modal v-if="$route.name === 'EXCMTaskList'"></add-to-my-calendar-modal>
    <create-task-modal @modalHidden="clearSelectedCase()" v-if="selectedCase" :id-case="selectedCase"></create-task-modal>
    <UpdateTaskParamsModal v-if="$route.name === 'EXCMTaskList'" @reload="getData()"></UpdateTaskParamsModal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import DispatchTaskModal from '@/components/Dashboard/Views/excmtask/components/DispatchTaskModal'
import CreateTaskModal from '@/components/Dashboard/Views/excmtask/modals/CreateTaskModal'
import TasksTable from '@/components/Dashboard/Views/excmtask/components/TasksTable'
import UpdateTaskParamsModal from '@/components/Dashboard/Views/excmtask/modals/UpdateTaskParamsModal'
import ApiService from '@/utils/ApiService'
import AddToMyCalendarModal from '@/components/Dashboard/Views/excmtask/components/AddToMyCalendarModal.vue'

export default {
  name: 'Table',
  components: {
    AddToMyCalendarModal,
    UpdateTaskParamsModal,
    TasksTable,
    CreateTaskModal,
    Loader,
    Pagination,
    DispatchTaskModal
  },

  props: {
    displayAssigned: {
      type: Boolean,
      default () {
        return true
      }
    },
    searchParams: Object
  },

  data () {
    return {
      selectedCase: ''
    }
  },

  computed: {
    searchParamsForApi () {
      let searchParams = JSON.parse(JSON.stringify(this.searchParams))
      if (searchParams['lastPoolTask.operationTransferUserData'] === false) {
        searchParams['lastPoolTask.operationTransferUserData[exists]'] = false
        searchParams['lastPoolTask.operationTransferUserData'] = undefined
      } else {
        searchParams['lastPoolTask.operationTransferUserData[exists]'] = undefined
      }
      return searchParams
    },
    dispatched: function () {
      return this.$store.state.modals.excmtask.dispatch.dispatched
    },
    addedToMyCalendar () {
      return this.$store.state.modals.excmtask.addToMyCalendar.added
    },
    ...mapGetters({
      view: 'excmtask/list/view',
      items: 'excmtask/list/items',
      isLoading: 'excmtask/list/isLoading',
      isCreateTaskModalVisible: 'excmtask/createModal/isVisible',
      createdTask: 'excmtask/create/created'
    })
  },

  watch: {
    searchParamsForApi: {
      deep: true,
      handler (val) {
        let url = 'e_x_c_m_tasks'
        this.getPage(addParamsToQuery(url, val))
      }
    },
    isCreateTaskModalVisible (val) {
      if (!val && this.createdTask) {
        this.getData()
        this.resetCreatedTask()
      }
    },
    dispatched: function (val) {
      if (val === 1) {
        this.getData()
      }
    },
    addedToMyCalendar: function (val) {
      if (val === 1) {
        this.getData()
      }
    }
  },
  created () {
    this.getData()
  },
  destroyed () {
    this.$store.state.checkboxes.selectedTasks = []
  },
  methods: {
    async takeMultipleTasks () {
      let params = {
        tasks: this.$store.state.checkboxes.selectedTasks
      }
      const response = await new ApiService(`e_x_c_m_tasks/take_tasks_multi`).post(params)
      if (response.status === 200 || response.status === 202 || response.status === 207) {
        this.$store.state.checkboxes.selectedTasks = []
        this.getData()
      }
    },
    updateSelectedCase (idCase) {
      this.selectedCase = idCase
    },
    getData () {
      let route = 'e_x_c_m_tasks'
      let link = (addParamsToQuery(route, this.searchParams))
      this.getPage(link)
    },
    setPageNum (num, itemsPerPage) {
      this.searchParams['_page'] = num
      this.searchParams['itemsPerPage'] = itemsPerPage
      this.getData()
    },
    clearSelectedCase () {
      this.selectedCase = ''
    },
    ...mapActions({
      getPage: 'excmtask/list/getItems',
      resetCreatedTask: 'excmtask/create/reset'
    }),
    ...mapMutations({
      toggleCreateTaskModal: 'excmtask/createModal/toggleModal'
    })
  }
}
</script>
